var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealtcare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#00c3d6",
    height: 117.2,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.0 -0.5 120.0 117.2",
    width: 120,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 0",
    fill: "inherit",
    stroke: "#449fdb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.184 70.532l8.588-33.272c0.456-1.772 2.108-3.172 3.916-2.924 1.832 0.068 3.368 1.4 3.696 3.2l7.916 43.528 4.4-8.436c0.672-1.296 2.008-2.1 3.464-2.1h31.252l8.2-9.092c0.28-0.324 0.508-0.684 0.676-1.064 4.384-7.464 7.716-13.928 7.716-22.484 0-18.444-15.244-34.020-33.284-34.020-10.84 0-20.564 4.888-26.704 13.1-6.224-8.456-16.12-13.652-26.728-13.652-18.040 0-33.284 15.868-33.284 34.66 0 8.484 3.172 14.668 7.688 22.348 0.168 0.404 0.404 0.776 0.704 1.112l8.212 9.088 23.572 0.008z",
    fill: "inherit"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.536 78.336l-8.556 16.432c-0.684 1.304-2.024 2.1-3.464 2.1-0.2 0-0.4-0.020-0.584-0.052-1.652-0.248-2.96-1.52-3.252-3.16l-6.784-37.264-4.908 19c-0.444 1.724-2 2.928-3.78 2.928h-19.544l33.512 37.072c0.744 0.816 1.796 1.28 2.896 1.28h0.004c1.104 0 2.164-0.464 2.896-1.288l33.416-37.064-21.852 0.016z",
    fill: "inherit"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealtcare);
export default __webpack_public_path__ + "static/media/healtcare.7c1b84718fbb94f47847b1c515e9e053.svg";
export { ForwardRef as ReactComponent };